import { Box, Typography } from "@mui/material";

import type { FormEvent, ReactNode } from "react";

import ToggleSoundButton from "@/components/ToggleSoundButton/ToggleSoundButton";
import { useSound } from "@/hooks/useSound";
import { BG_AUDIO, BG_VIDEO } from "@/routes/-authStyles";

interface AuthLayoutProps {
  title: string;
  children: ReactNode;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
}

export default function AuthLayout({
  title,
  children,
  onSubmit,
}: AuthLayoutProps) {
  const { isPlaying, toggleSound } = useSound(BG_AUDIO);

  const contentProps = onSubmit ? { component: "form" as const, onSubmit } : {};

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        component="video"
        src={BG_VIDEO}
        autoPlay
        loop
        muted
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "640px",
          zIndex: 9,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "24px",
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            padding: "48px",
            width: "100%",
          }}
          {...contentProps}
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 400,
              fontSize: "48px",
              fontFamily: "'Lust', sans-serif",
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
          {children}
          <ToggleSoundButton
            isPlaying={isPlaying}
            onClick={toggleSound}
            sx={{
              position: "absolute",
              bottom: "-128px",
              right: "50%",
              transform: "translateX(50%)",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
